/*
 * (c) Copyright 2024 Calabrio, Inc.
 * All Rights Reserved. www.calabrio.com LICENSED MATERIALS
 * Property of Calabrio, Inc., Minnesota, USA
 *
 * No part of this publication may be reproduced, stored or transmitted,
 * in any form or by any means (electronic, mechanical, photocopying,
 * recording or otherwise) without prior written permission from Calabrio, Inc.
 */

const WyGenie = {
  featureFlagKey: 'analytics.enable-genie-bot',
  cacheSessionExpiryInMinutes: 180, // 3 hours
  cacheSessionPrefix: 'genieCache',

  cacheService: sessionStorage,

  _getGenieSessionCachedObj(authUser) {
     // genie bot cache
    let genieBotCachedObj = {}

    // genie bot cache key by genie bot token
    const genieTokenHashedKey = `${this.cacheSessionPrefix}-${authUser.productName}-${authUser.companyId}-${authUser.user.id}`;
    if(this.cacheService.getItem(genieTokenHashedKey)) {
      genieBotCachedObj = JSON.parse(this.cacheService.getItem(genieTokenHashedKey));
    }

    return genieBotCachedObj;
  },

  getGenieCachedSessionId(authUser, payloadHash) {
    const genieCachedObj = this._getGenieSessionCachedObj(authUser);
    
    if (genieCachedObj && genieCachedObj.sessions) {
      const sessionEntry = genieCachedObj.sessions[payloadHash];
      if (sessionEntry) {
        const parts = sessionEntry.split('_');
        const sessionId = parts[0];
        const sessionTime = parseInt(parts[1], 10);

        if ((new Date()).getTime() <= sessionTime) {
          return {
            sessionId: sessionId,
            veid: genieCachedObj.veid,
            baseUrl: genieCachedObj.baseUrl
          };
        }
      }
    }
    
    return null;
  },

  createGenieCachedSessionId(authUser, payloadHash, genieData) {
    let genieCachedObj = this._getGenieSessionCachedObj(authUser);
    const sessionTime = (new Date()).getTime() + (this.cacheSessionExpiryInMinutes * 60 * 1000);

    if (!genieCachedObj || !genieCachedObj.sessions) {
      genieCachedObj = {
        veid: genieData.veid,
        baseUrl: genieData.baseUrl,
        sessions: {}
      };
    } else {
      genieCachedObj.veid = genieData.veid;
      genieCachedObj.baseUrl = genieData.baseUrl;
    }

    genieCachedObj.sessions[payloadHash] = `${genieData.sessionId}_${sessionTime}`;

    const genieTokenHashedKey = `${this.cacheSessionPrefix}-${authUser.productName}-${authUser.companyId}-${authUser.user.id}`;
    this.cacheService.setItem(genieTokenHashedKey, JSON.stringify(genieCachedObj));
  },

  clearAllGenieCachedSessions(authUser) {
    const genieTokenHashedKey = `${this.cacheSessionPrefix}-${authUser.user.productName}-${authUser.user.companyId}-${authUser.user.id}`;
    this.cacheService.removeItem(genieTokenHashedKey);
  },


  createGenieLoggingPayload(pageName, lastMessage, totalConversations, sourceObj) {
    if(!lastMessage) {
      return null;
    }
    if(!lastMessage.role || !lastMessage.content) {
      return null;
    }
    if(lastMessage.role === 'user') {
      const payload = {
        pageName: pageName,
        role: lastMessage.role,
        totalConversations: totalConversations,
        source: sourceObj
        
        
      };
      return payload;
    } else if (lastMessage.role === 'assistant') {
      const payload = {
        pageName: pageName,
        role: lastMessage.role,
        totalConversations: totalConversations,
        source: sourceObj
      };
      return payload;
    }
    return null;
  },
};

export default WyGenie;